import React from 'react';
import styled from 'styled-components';
import { mediaQuery, typography } from '../../../../../theme';
import { storyblokEditable } from '@storyblok/react';
import Markdown from 'markdown-to-jsx';
import { AddressSelectionData } from '../../../types';
import { useStory } from '../../../../storyblok/hooks/useStoryblok';
import { colors } from '../../../../../theme/color';

export const DynamicDeliveryFeeInfo: React.FC = () => {
  const { data } = useStory<AddressSelectionData>('address-selection', 'addressSelection');

  if (!data) return null;

  const { description, title, link, link_label } = data;

  return (
    <BannerDynamicPriceWrapper>
      <BannerDynamicPrice>
        <BannerTitle>
          <h4>{title}</h4>
        </BannerTitle>
        <DynamicBannerTextContent {...storyblokEditable(data)}>
          {description}
        </DynamicBannerTextContent>
        <BannerLink>
          <typography.Link to={link?.url}>
            {link_label}
            <span> →</span>
          </typography.Link>
        </BannerLink>
      </BannerDynamicPrice>
    </BannerDynamicPriceWrapper>
  );
};

const BannerDynamicPriceWrapper = styled.div`
  background: ${colors.white};
  position: relative;
  margin-bottom: 30px;

  @media ${mediaQuery.medium} {
    width: auto;
  }
`;

const BannerDynamicPrice = styled.div`
  background: ${colors.green.lighter(90)};
  background-size: 50% auto;
  box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: ${colors.black};
  position: relative;
  overflow: hidden;

  & ul {
    margin-top: 4px;
    margin-left: 16px;

    & > li:not(:last-child) {
      padding-bottom: 4px;
    }
  }
`;

const BannerTitle = styled.div`
  padding: 16px 16px 4px 16px;
  text-align: left;

  & h4 {
    font-weight: 700;
    font-size: 18px;
    line-height: 125%;
    margin: 0;
  }
`;

const BannerContent = styled(Markdown)`
  z-index: 2;
  text-align: left;
  margin-left: 0;
  width: 80%;
  font-size: 16px;
  line-height: 20px;
  font-family: var(--font-libre-franklin), system-ui, sans-serif;
  text-align: left;
  padding: 4px 16px 4px 16px;
  margin-bottom: 8px;

  & p {
    margin: 8px 0;
  }

  & strong {
    color: ${colors.textSuccess};
    font-weight: 700;
  }

  @media ${mediaQuery.medium} {
    font-size: 13px;
    margin: 4px 0;
    width: 100%;
    max-width: none;

    & p {
      margin: 4px 0;
    }
  }
`;

const BannerLink = styled.div`
  margin: 0 16px 16px 16px;
  text-align: left;

  & a {
    ${typography.linkStyle}
    color: black;
  }

  & span {
    color: ${colors.black};
    font-size: 16px;
    line-height: 125%;
  }
`;

const DynamicBannerTextContent = styled(BannerContent)`
  ${typography.paragraphMediumStyle}
  width: 100%;
`;
